import {
    AfterViewInit,
    Component,
    Inject,
    OnInit,
    ViewChild, effect} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { Clinic } from '../services/clinic.model';
import { UntypedFormControl, Validators } from '@angular/forms';
import { IdentifierService } from 'merlin-core';
import { TranslateService } from '@ngx-translate/core';
import { PopupConfig, PopupService, PopupType, SortDirection, UserProfileObject } from 'merlin-library';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { UserService } from 'merlin-library';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
@Component({
    selector: 'app-release-patient-dialog',
    templateUrl: './release-patient-dialog.component.html',
    styleUrls: ['./release-patient-dialog.component.scss'],
    standalone: false
})
export class ReleasePatientDialogComponent implements OnInit, AfterViewInit {
    displayedColumns: string[] = [
        'lastName',
        'patientNumber',
        'isTransmissionComplete',
    ];
    patientDataSource;

    clinicColumns: string[] = ['name', 'address', 'phoneNumber', 'selected'];
    clinicDataSource:MatTableDataSource<any>;;
    selection = new SelectionModel<Clinic>(false, []);
    reasonForReasonFlag: string | null = 'B';
    reasonForReasonCode;
    sortDirection: any = SortDirection.ASC;
    sortActiveKey: string = 'name';
    errorMsgs = [];
    customerApplicationId: number;
    selectedClinicDetails;
    isActivatorClinic: boolean;
    releaseDataForActivatorClinic = [];
    releaseDataForNonActivatorClinic;
    completedTransmissionCount: number;
    InCompletedTransmissionCount: number;
    reason = new UntypedFormControl('', Validators.required);
    isTransmissionCompleted: boolean = false;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    showInfoMessage = true;
    releaseReasonCd;
    transferCustApplId;
    countryCodes: any;

    public stringLabels = [
        "label.gb.rel_pat",
        "label.gb.transmission_not_complete",
        "label.gb.Patient",
        "label.rpt.PRN",
        "label.gb.patient_id_prefix",
        "label.gb.message",
        "label.gb.unarchived_transmissions",
        "label.gb.transferred_to_another_clinic",
        "label.gb.reason_for_patient_release",
        "label.gb.unassigned_referring_clinic",
        "label.gb.reason_explanted",
        "label.gb.reason_removed",
        "label.gb.expired",
        "label.gb.referringclinic_intro_text",
        "label.gb.actclinic_release_intro_text",
        "label.gb.clinicname",
        "label.gb.address",
        "label.gb.phone_number",
        "label.gb.required_field",
        "label.gb.button_cancel",
        "label.gb.release",
        "msg.pa898.text"
    ]

    public labels: Record<string, string>;

    public completedTransmissionCountLabel;

    constructor(
        public dialogRef: MatDialogRef<ReleasePatientDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        public identifierService: IdentifierService,
        private userService: UserService,
        public translateService: TranslateService,
        private popupService: PopupService,
        private localizationService: LocalizationService,
        private toastrService: ToastrService,

    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
        this.patientDataSource = data.patients;
        data.clinicFavoriteDTO.forEach((obj, index) => {
            if (obj.associatedCustApplId != -1) {
                this.releaseDataForActivatorClinic.push(obj);
            }
        });
        this.releaseDataForNonActivatorClinic = data.clinicFavoriteDTO;
        this.countryCodes = data.countryCodes;
        const completedTransmission = data.patients.filter((patient) => {
            return patient.isTransmissionComplete === true;
        });
        this.completedTransmissionCount = completedTransmission.length;
        this.completedTransmissionCountLabel = this.translate('msg.pa051.prompt', this.completedTransmissionCount);
        // this.isTransmissionCompleted =
        //     data.patients.length === this.completedTransmissionCount;
        this.isTransmissionCompleted = this.completedTransmissionCount >= 1;
        this.InCompletedTransmissionCount =
            data.patients.length - this.completedTransmissionCount;
        if (data?.releaseReasonCd) {
            this.releaseReasonCd = data.releaseReasonCd;
        } else if (data?.clinicFavoriteDTO?.length) {
            this.releaseReasonCd = this.releaseReasonCd;
        }
        this.transferCustApplId = data.transferCustApplId;
        if (this.transferCustApplId) {
            this.setDefaultClinicDetails(data.clinicFavoriteDTO);
        }
        this.getUserData();
    }

    getAddress(address) {
        let completeAddress = [
            address?.streetAddress, address?.streetAddress2, address?.streetAddress3,
            address?.city, address?.stateProvince, this.getCountry(address), address?.zipCode
        ]
        return completeAddress.filter((el) => el != null && el != '').join(', ');
    }
    getCountry(address) {
        return address?.countryName ? this.translate('data.Code.Country_Cd.Code_Desc.'+address?.countryName): '';
    }

    sortChange(sortEvent: Sort) {
        this.clinicDataSource.sort = this.sort;
    }

    getUserData() {
        this.userService.getUserObs().subscribe((userData: UserProfileObject)=>{
            if (userData) {
                this.userProfileCallback(userData);
            } else {
                this.userService.getUserProfile(false).subscribe((userData) => {
                    this.userService.setUserObs(userData);
                    this.userProfileCallback(userData);
                });
            }
        })

    }
    userProfileCallback(userData) {
        this.isActivatorClinic = userData.activatorClinicFlg;
        if (this.isActivatorClinic === true) {
            this.clinicDataSource = new MatTableDataSource(this.releaseDataForActivatorClinic);
        } else {
            this.clinicDataSource = new MatTableDataSource(this.releaseDataForNonActivatorClinic);
        }
        this.clinicDataSource.sortingDataAccessor = (item: any, property) => {
            switch (property) {
                default:
                    return item[property]?.toLowerCase();
            }
        };
        this.clinicDataSource.sort = this.sort;
    }

    ngOnInit() {
        this.translateStrings();
        if(this.data.releaseReasonCd){
            switch (this.data.releaseReasonCd) {
                case 48:
                    this.reasonForReasonFlag = 'R';
                    break;
                case 281:
                    this.reasonForReasonFlag = 'E';
                    break;
                case 47:
                    this.reasonForReasonFlag = 'D';
                    break;
                case 158:
                    this.reasonForReasonFlag = 'X';
                    break;
                default:
                    this.reasonForReasonFlag = 'B';
                    break;
            }
        }
       // this.selectedRecord();
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    setDefaultClinicDetails(clinics) {
        const filteredClinic = clinics.filter((clinic, i) => {
            return clinic.associatedCustApplId == this.transferCustApplId;
        })[0];
        this.selectedClinicDetails = filteredClinic;
    }
    // onNoClick(): void {
    //     this.dialogRef.close();
    // }

    dropDownSelect() {
        this.errorMsgs = [];
        const labelText = (this.localizationService.generateLocalizedStr('label.gb.actclinic_unassociated_text').replace('\\n','<br>&nbsp&nbsp&nbsp&nbsp&nbsp')).replace('\\n','<br>&nbsp&nbsp&nbsp&nbsp&nbsp');
        if((!this.data.clinicFavoriteDTO.length || this.transferCustApplId === -1) && this.reasonForReasonFlag == 'R' && this.isActivatorClinic){
            const dialogConfig: PopupConfig = {
                type: PopupType.Prompt,
                message: labelText,
                confirmText:
                    this.localizationService.generateLocalizedStr(
                        'label.gb.ok'
                    ),
                confirmId: this.identifierService.buttonId(
                    'release-patient-popup',
                    'Ok'
                ),
                customPopup: true,
            };
            this.popupService.open(dialogConfig);
        //    this.popupService.confirmed().toPromise();
        } else if (this.reasonForReasonFlag === 'X'
            || this.reasonForReasonFlag === 'D'
            || this.reasonForReasonFlag === 'E' || this.reasonForReasonFlag === 'R') {
                if(this.reasonForReasonFlag === 'R' && this.transferCustApplId == null){
                        const msg = this.localizationService.generateLocalizedStr('label.gb.actclinic_release_intro_text');
                        this.toastrService.error(msg, null, {
                            closeButton: true,
                            disableTimeOut: true
                        });
                }else{
                    this.dialogRef.close({
                        reasonForReasonFlag: this.reasonForReasonFlag,
                        transferCustApplId: this.transferCustApplId,
                        selectedClinicDetails: this.selectedClinicDetails,
                    });
                }

        } else if (this.reasonForReasonFlag !== 'B' && this.reasonForReasonFlag !== '' && this.reasonForReasonFlag !== null) {
            if(this.selectedClinicDetails === undefined){
                const selectClinic = this.localizationService.generateLocalizedStr('label.gb.actclinic_release_intro_text');
                this.toastrService.error( selectClinic);
                this.dialogRef.disableClose = true;
            }
            else if (this.transferCustApplId) {
                this.dialogRef.close({
                    reasonForReasonFlag: this.reasonForReasonFlag,
                    transferCustApplId: this.transferCustApplId,
                    selectedClinicDetails: this.selectedClinicDetails,
                });
            }
        } else {
            const dialogConfig: PopupConfig = {
                type: PopupType.Prompt,
                message: this.translateService.instant('msg.pa855.text'),
                confirmText:
                    this.localizationService.generateLocalizedStr(
                        'label.gb.ok'
                    ),
                confirmId: this.identifierService.buttonId(
                    'release-patient-popup',
                    'Ok'
                ),
                customPopup: true,
            };
            this.popupService.open(dialogConfig);
            this.popupService.confirmed().toPromise();
            // this.errorMsgs.push(
            //     this.translateService.instant('msg.pa855.text')
            // );
            return;
        }
    }

    updateReleaseReasonCode(code) {
        switch (code) {
            case 'R':
                this.reasonForReasonCode = 48;
                break;
            case 'E':
                this.reasonForReasonCode = 281;
                break;
            case 'D':
                this.reasonForReasonCode = 47;
                break;
            case 'X':
                this.reasonForReasonCode = 158;
                break;
            default:
                this.reasonForReasonCode = '';
                break;
        }
    }
    ngAfterViewInit() {
        console.log(this.clinicDataSource);
        if (this.sort) this.clinicDataSource.sort = this.sort;
    }
    primaryClick(element) {
        //console.log(element);
        this.customerApplicationId = element.associatedCustApplId;
        this.transferCustApplId = element.associatedCustApplId;
        this.selectedClinicDetails = element;
        return true;
    }

    hideInfoPanel() {
        this.showInfoMessage = false;
    }

    reasonForSelected(event) {
        this.reasonForReasonFlag = event.value;
        this.showInfoMessage = true;
        // this.selectedRecord();
    }
    selectedRecord() {
        if (this.reasonForReasonFlag === 'R') {
            this.clinicColumns = [
                'name',
                'address',
                'phoneNumber',
                'selected',
            ];
        } else {
            this.clinicColumns = ['name', 'address', 'phoneNumber'];
        }
    }
    translate(key: string, params:any = null) {
        if (!params) {
            return this.localizationService.generateLocalizedStr(key,null,'html');
        } else {
            return this.localizationService.generateLocalizedStr(key, {
                0: params
            }, 'html')
        }
    }
}
